import React from "react";

export default function CanvasToolbar({Viewer}) {
	return (
		<></>
	);
}